import { visualEntities } from "../entities.js";
import { create } from "../helpers/elements.helper.js";
import { VisualSuperHtml } from "./visual-super.environment.js";

class LinkHtml extends VisualSuperHtml {
  setProps(eNode) {
    eNode.element = create(eNode, "a");

    super.setProps(eNode);

    eNode.element.setAttribute("href", eNode.props.url);
    eNode.element.setAttribute("target", eNode.props.target);
    eNode.element.style.pointerEvents = "auto";
    eNode.element.style.cursor = "pointer";
    eNode.element.style.textDecoration = "none";
    eNode.element.style.display = "inline-block";
    eNode.element.style.color = "inherit";

    if (eNode.props.text_content) {
      eNode.element.innerHTML = eNode.props.text_content;
    }

    if (eNode.props.tooltip) {
      eNode.element.setAttribute("title", eNode.props.tooltip);
    }

    if (eNode.props.download) {
      eNode.element.setAttribute("download", "");
    }
  }
}

const linkHtml = new LinkHtml("visual:link");
visualEntities.set("visual:link", linkHtml);
export { LinkHtml, linkHtml };
